import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const STORE_LIMIT = 100;
export const VIEW_LIMIT = 5;
const NOT_FOUND = -1;
export interface ISearchInput {
  keyHistory: string;
  value: string;
}
export interface ISearchLinkInput {
  keyHistory: string;
  value: ILinkData;
}
export interface ILinkData {
  labelOne: string;
  labelTwo?: string;
  link: string;
  thumbnail?: string;
  studioId?: string;
}
export interface IAutoComplete {
  labelOne: string;
  table?: string;
  id?: string;
}
export interface ISearchHistory {
  keyHistory: string;
  history: string[];
}
export interface ISearchLinkHistory {
  keyHistory: string;
  history: ILinkData[];
}
export interface IFilter {
  recentSearches: ISearchHistory[];
  recentViewed: ISearchLinkHistory[];
}
export const searchSlice = createSlice({
  name: 'search',
  initialState: {
    recentSearches: [],
    recentViewed: [],
  } as IFilter,
  reducers: {
    updateRecentSearches: (state, action: PayloadAction<ISearchInput>) => {
      if (action.payload.value.length === 0) return;
      const indexOfSearch = state.recentSearches.findIndex(
        item => item.keyHistory === action.payload.keyHistory,
      );
      if (indexOfSearch === NOT_FOUND) {
        state.recentSearches.push({
          keyHistory: action.payload.keyHistory,
          history: [action.payload.value],
        });
      } else {
        state.recentSearches[indexOfSearch].history = state.recentSearches[
          indexOfSearch
        ].history.filter(
          item => item.toLowerCase() !== action.payload.value.toLowerCase(),
        );

        state.recentSearches[indexOfSearch].history.unshift(
          action.payload.value,
        );

        if (state.recentSearches[indexOfSearch].history.length >= STORE_LIMIT) {
          state.recentSearches[indexOfSearch].history.pop();
        }
      }
    },
    updateRecentViewed: (state, action: PayloadAction<ISearchLinkInput>) => {
      if (action.payload.value.labelOne.length === 0) return;
      const indexOfSearch = state.recentViewed.findIndex(
        item => item.keyHistory === action.payload.keyHistory,
      );
      if (indexOfSearch === NOT_FOUND) {
        state.recentViewed.push({
          keyHistory: action.payload.keyHistory,
          history: [action.payload.value],
        });
      } else {
        state.recentViewed[indexOfSearch].history = state.recentViewed[
          indexOfSearch
        ].history.filter(item => item.link !== action.payload.value.link);

        state.recentViewed[indexOfSearch].history.unshift(action.payload.value);

        if (state.recentViewed[indexOfSearch].history.length >= STORE_LIMIT) {
          state.recentViewed[indexOfSearch].history.pop();
        }
      }
    },
    removeRecentViewed: (state, action: PayloadAction<ISearchLinkInput>) => {
      const indexOfSearch = state.recentViewed.findIndex(
        item => item.keyHistory === action.payload.keyHistory,
      );

      if (indexOfSearch !== NOT_FOUND) {
        state.recentViewed[indexOfSearch].history = state.recentViewed[
          indexOfSearch
        ].history.filter(item => item.link !== action.payload.value.link);
      }
    },
    clearFilter: state => {
      state.recentSearches = [];
      state.recentViewed = [];
    },
  },
});

export const {
  updateRecentSearches,
  updateRecentViewed,
  clearFilter,
  removeRecentViewed,
} = searchSlice.actions;

export const { reducer: searchReducer } = searchSlice;
